import Vue from 'vue'
import Vuex from 'vuex'

import menu from './menu'
import tab from './tab'
import dic from './dictionary'
Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    menuModule: { ...menu },
    tabModule: { ...tab },
    dicModule: { ...dic }
  }
})
